import { render, staticRenderFns } from "./CustomerOdontogram.vue?vue&type=template&id=7f1b858e"
import script from "./CustomerOdontogram.vue?vue&type=script&lang=js"
export * from "./CustomerOdontogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports